import type { Locale, Translator } from '@porotutu/i18n'
import { stampedAt } from '@porotutu/i18n'
import { type Column, RowLink } from '@porotutu/react/components/DataTable/DataTable'
import { StatusBadge } from '@porotutu/react/components/StatusBadge/StatusBadge'
import type { AuditListQuery, Entry } from '../queries'

export const actorOf = (t: Translator, entry: Entry) =>
  entry.actor_name === '' ? t('adm.audit.row.system') : entry.actor_name

export const subjectOf = (t: Translator, entry: Entry) =>
  entry.subject_name === '' ? t('audit.blank') : entry.subject_name

export const actorEmailOf = (t: Translator, entry: Entry) =>
  entry.actor_email === '' ? t('audit.blank') : entry.actor_email

export const subjectEmailOf = (t: Translator, entry: Entry) =>
  entry.subject_email === '' ? t('audit.blank') : entry.subject_email

export const actorAddressOf = (t: Translator, entry: Entry) =>
  entry.actor_address === null ? t('audit.blank') : entry.actor_address

export const realmOf = (t: Translator, entry: Entry) =>
  entry.realm === null ? t('audit.blank') : t(`adm.users.tabs.${entry.realm}`)

export const columnsFor = (
  t: Translator,
  locale: Locale,
  query: AuditListQuery,
): Array<Column<Entry>> => [
  {
    key: 'when',
    header: t('adm.audit.table.when'),
    sortKey: 'created_at',
    cell: (row) => (
      <RowLink to="/audit/$id" params={{ id: row.id }} search={query}>
        {stampedAt(row.created_at, locale)}
      </RowLink>
    ),
  },
  {
    key: 'who',
    header: t('adm.audit.table.who'),
    sortKey: 'who',
    cell: (row) => actorOf(t, row),
  },
  {
    key: 'subject',
    header: t('adm.audit.table.subject'),
    cell: (row) => subjectOf(t, row),
  },
  {
    key: 'realm',
    header: t('adm.audit.table.realm'),
    cell: (row) => realmOf(t, row),
  },
  {
    key: 'kind',
    header: t('adm.audit.table.kind'),
    sortKey: 'kind',
    cell: (row) => t(`adm.audit.kind.${row.resource_kind}`),
  },
  {
    key: 'action',
    header: t('adm.audit.table.action'),
    sortKey: 'action',
    cell: (row) => <StatusBadge status={row.action_type} scope="adm.audit.action" />,
  },
]
